// extracted by mini-css-extract-plugin
export default {"appointmentConfirmation":"YPsxK9P2ZQoBYznI70DW"};